"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var CrossedOutEyeIcon = function CrossedOutEyeIcon(props) {
  return _react["default"].createElement("svg", (0, _extends2["default"])({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _react["default"].createElement("title", null, props["aria-label"]), _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13.967 15.325l-.992-1.09c-.29.09-.599.138-.92.138-1.68 0-3.043-1.332-3.043-2.975 0-.438.097-.854.27-1.228L7.604 8.323c-1.757.707-3.114 1.862-3.742 3.248 1.053 2.324 4.153 3.998 7.759 3.998.813 0 1.601-.085 2.346-.244zm1.817-.567c1.806-.761 3.168-2.002 3.715-3.477a.875.875 0 0 1 1.114-.509c.451.16.685.648.52 1.089-.664 1.791-2.17 3.269-4.143 4.224l1.897 2.088c.318.35.295.9-.05 1.228a.838.838 0 0 1-1.203-.04l-2.372-2.61a12.846 12.846 0 0 1-3.641.518c-4.434 0-8.323-2.2-9.513-5.408L2 11.571l.108-.29c.68-1.834 2.244-3.34 4.284-4.292L3.964 4.317a.882.882 0 0 1 .051-1.228.838.838 0 0 1 1.202.04l2.921 3.215a12.821 12.821 0 0 1 3.467-.47c2.69-.048 4.625.258 5.843.97a.84.84 0 0 1 .301 1.165.88.88 0 0 1-1.192.294c-.875-.51-2.528-.772-4.936-.73-.752 0-1.482.073-2.176.209l.995 1.094a3.08 3.08 0 0 1 1.615-.453c1.681 0 3.044 1.332 3.044 2.975 0 .706-.252 1.355-.673 1.866l1.358 1.494zm4.554-5.463a1.048 1.048 0 0 1-1.458 0 .992.992 0 0 1 0-1.427 1.047 1.047 0 0 1 1.458 0 .992.992 0 0 1 0 1.427z"
  }));
};

CrossedOutEyeIcon.defaultProps = {
  width: "24px",
  height: "24px",
  "aria-label": "Crossed Out Eye Icon",
  color: "#233750"
};
var _default = CrossedOutEyeIcon;
exports["default"] = _default;